const getters = {
  taxonomy: state => {
    
  },
}
export default getters
